const aiGovernanceList = () => import('@/views/pages/aiGovernance/aiGovernanceList/index.vue');

const aiGovernanceRouteList = [
  {
    path: 'aiGovernance',
    component: aiGovernanceList,
    name: '/aiGovernance',
    meta: {
      ownType: 'aiGovernance',
      lableTitle: 'AI Governance',
    },
  },
];

export default aiGovernanceRouteList;
